import { ReactNode } from 'react';
import { Brand } from './Logo';

export function AuthLayout({
  title,
  children,
  footer,
}: {
  title: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <div className="min-h-full flex items-center justify-center bg-hs-bg px-4 py-10">
      <div className="w-full max-w-[380px]">
        <div className="flex justify-center mb-6">
          <Brand />
        </div>
        <div className="bg-hs-surface border border-hs-border rounded-hs-xl p-7">
          <h1 className="font-display font-bold tracking-hs-tight text-[24px] text-hs-text mb-5">{title}</h1>
          {children}
        </div>
        <p className="mt-5 text-center text-[13.5px] text-hs-text-mute">{footer}</p>
      </div>
    </div>
  );
}
